import { render, staticRenderFns } from "./PandLReport.vue?vue&type=template&id=edd5dbc6&scoped=true&"
import script from "./PandLReport.vue?vue&type=script&lang=js&"
export * from "./PandLReport.vue?vue&type=script&lang=js&"
import style0 from "./PandLReport.vue?vue&type=style&index=0&id=edd5dbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd5dbc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edd5dbc6')) {
      api.createRecord('edd5dbc6', component.options)
    } else {
      api.reload('edd5dbc6', component.options)
    }
    module.hot.accept("./PandLReport.vue?vue&type=template&id=edd5dbc6&scoped=true&", function () {
      api.rerender('edd5dbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/accountingreport/PandLReport.vue"
export default component.exports